import vehiclesData from './vehicles.drivesource.json';
import { Vehicle } from '@/types/vehicle.types';

export const getVehicles = (): Vehicle[] => vehiclesData as Vehicle[];

export const getVehicleByMakeModel = (make: string, model: string): Vehicle | undefined =>
    getVehicles().find(v => v.make.toLowerCase() === make.toLowerCase() && v.model.toLowerCase() === model.toLowerCase());
